// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"e02836c99aaa2187","node_modules_canvg_lib_index_es_js":"2d00d1d00b9b5b2a"}[chunkId] + ".js";
};